import { useContext } from "react"
import { PageContext } from "../context/PageContext"
import useArticlePath from "./useArticlePath"
import useProductPath from "./useProductPath"
import useRoutePath from "./useRoutePath"
import useSiteMetadata, { SiteMetadataLocale } from "./useSiteMetadata"

/*

  https://developers.google.com/search/docs/advanced/crawling/localized-versions

  <head>
    <link rel="alternate" hreflang="en-gb"
        href="https://en-gb.example.com/page.html" />
    <link rel="alternate" hreflang="en-us"
        href="https://en-us.example.com/page.html" />
    <link rel="alternate" hreflang="en"
        href="https://en.example.com/page.html" />
    <link rel="alternate" hreflang="de"
        href="https://de.example.com/page.html" />
    <link rel="alternate" hreflang="x-default"
        href="https://www.example.com/" />
  </head>

  */

export type AlternatePaths = {
  locale: SiteMetadataLocale
  path?: string
  current: boolean
}[]

const _store: Record<string, AlternatePaths> = {}

const useAlternatePaths = () => {
  const page = useContext(PageContext)
  const getProductPath = useProductPath()
  const getArticlePath = useArticlePath()
  const getRoutePath = useRoutePath()
  const { locales } = useSiteMetadata()

  const key = page.originalId || page.sku

  if (!key) return []
  if (!locales) return []

  // ei cacheteta, että kielen vaihtaminen toimii
  //if (_store[key]) return _store[key]

  const alternates = locales.map(itm => {
    return {
      locale: itm,
      current: page.locale === itm.dato,
      path:
        (page.sku && getProductPath(page.sku, itm.dato)) ||
        getArticlePath(page.originalId, itm.dato) ||
        getRoutePath(page.originalId, itm.dato),
    }
  })

  _store[key] = alternates

  return _store[key]
}

export default useAlternatePaths
